"use strict";
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            Framework_ActOnDataShortcuts: "Act on data",
            Framework_AvailableShortcuts: "Currently Available Shortcuts",
            Framework_CloseShortcuts: "Close",
            Framework_ElementActions: "Shortcuts for selected element",
            Framework_NavigateShortcuts: "Navigate",
            Framework_OtherShortcuts: "Other",
            Framework_ViewAllProductShortcuts: "View all product shortcuts",
            Framework_ViewShortcuts: "View shortcuts",
        }
    });
    function showAvailableShorcutsDialog(shortcuts) {
        var dialog = new $dyn.controls.AvailableShortcutsLightBox(shortcuts);
        var options = {
            context: dialog,
            role: "Dialog",
            templateId: "AvailableShortcutsLightBox",
        };
        $dyn.shell.createForm(options);
        $dyn.shell.dialog(options);
    }
    $dyn.showAvailableShorcutsDialog = showAvailableShorcutsDialog;
    var controls;
    (function (controls) {
        var AvailableShortcutsLightBox = /** @class */ (function () {
            function AvailableShortcutsLightBox(shortcuts) {
                this.shortcuts = shortcuts;
                this.ElementActionsVisible = $dyn.length(shortcuts[$dyn.ui.ShortcutCategory.ElementAction]) > 0;
                this.NavigateVisible = $dyn.length(shortcuts[$dyn.ui.ShortcutCategory.Navigate]) > 0;
                this.ActOnDataVisible = $dyn.length(shortcuts[$dyn.ui.ShortcutCategory.ActOnData]) > 0;
                this.CloseVisible = $dyn.length(shortcuts[$dyn.ui.ShortcutCategory.Close]) > 0;
                this.OtherVisible = $dyn.length(shortcuts[$dyn.ui.ShortcutCategory.Other]) > 0;
            }
            AvailableShortcutsLightBox.prototype.closeClicked = function () {
                $dyn.shell.dialogBack();
            };
            return AvailableShortcutsLightBox;
        }());
        controls.AvailableShortcutsLightBox = AvailableShortcutsLightBox;
        AvailableShortcutsLightBox.prototype.headerText = $dyn.label("Framework_AvailableShortcuts");
        AvailableShortcutsLightBox.prototype.ElementActionsLabel = $dyn.label("Framework_ElementActions");
        AvailableShortcutsLightBox.prototype.NavigateLabel = $dyn.label("Framework_NavigateShortcuts");
        AvailableShortcutsLightBox.prototype.ActOnDataLabel = $dyn.label("Framework_ActOnDataShortcuts");
        AvailableShortcutsLightBox.prototype.CloseLabel = $dyn.label("Framework_CloseShortcuts");
        AvailableShortcutsLightBox.prototype.OtherLabel = $dyn.label("Framework_OtherShortcuts");
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=AvailableShortcutsLightBox.js.map
